module.exports = __webpack_public_path__ + "static/img/help-upgrade.772c195a.png";